import { AlertOutlineIcon } from './AlertOutlineIcon';

/**
 * author: Simran
 * id 4E574535-954C-42F5-BE5B-DF3716DB7C5A
 * name alert-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const WarningOutlineIcon = AlertOutlineIcon;
export default WarningOutlineIcon